import { Component, OnInit } from '@angular/core';
import { DownloadsService } from '../../core/services/downloads.service';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss'],
})
export class DownloadsComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Downloads',
    },
  ];

  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 24;

  constructor(
    private downloadsService: DownloadsService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.downloadsService
      .getDownloads(this.currentPage, this.pageSize)
      .then((response: any) => {
        this.data = response.docs || [];
        this.totalDocs = response.totalDocs || 0;
      });
  }

  onCurrentPageDataChange(page: number): void {
    this.currentPage = page;
    this.loadData();
  }

  getFileUrl(file: any): string {
    if (file && file.url) {
      return file.url;
    }
    if (file && typeof file === 'string') {
      return file;
    }
    return '#';
  }

  hasAnyFile(doc: any): boolean {
    return this.getFileUrl(doc.englishFile) !== '#' || 
           this.getFileUrl(doc.sinhalaFile) !== '#' || 
           this.getFileUrl(doc.tamilFile) !== '#';
  }
}




